import React from 'react';
import colours from 'styles/colours';
import Icon from 'components/Notifications/Icon';

export default function Message({type, children}) {

    const size = 10;
    const containerStyles = {
        display: 'flex',
        position: 'relative',
        border: 0,
        backgroundColor: 'inherit',
        padding: size,
        paddingLeft: size - 4,
        alignItems: 'center',
        color: colours.font.main
    }

    return <dialog style={containerStyles}>
        <Icon type={type} size={size} width={(size * 2) + 7} height={(size * 2) + 1} />
        {children}
    </dialog>

}